// Saved delivery addresses (supabase/migrations/20261020014755_market_addresses.sql). A customer
// reads and writes only their own rows — RLS on auth.uid(), not this file.
// The page validates with src/lib/saAddress.js; the database checks again.
import { marketDb } from './marketDb';
import { normalizeSaMobile, normalizeShortAddress, toLatinDigits } from './saAddress';

const COLS = 'id, label, recipient_name, mobile, short_address, city, district, street, building_no, postal_code, additional_no, unit, details, instructions, lat, lng, is_default, updated_at';

/** row (snake_case) → the address shape the form and saAddress.js use (camelCase). */
export const fromRow = (r) => ({
  id: r.id, label: r.label || '', name: r.recipient_name, phone: r.mobile, shortAddress: r.short_address, city: r.city, district: r.district,
  street: r.street, buildingNo: r.building_no, postalCode: r.postal_code || '', additionalNo: r.additional_no || '', unit: r.unit || '',
  details: r.details || '', instructions: r.instructions || '', lat: r.lat, lng: r.lng, isDefault: r.is_default,
});
/** address → row values (call after validateAddress is empty). */
export const toRow = (a) => ({
  label: String(a.label || '').trim() || null,
  recipient_name: String(a.name).trim(),
  mobile: `+966${normalizeSaMobile(a.phone)}`,
  short_address: normalizeShortAddress(a.shortAddress),
  city: String(a.city).trim(), district: String(a.district).trim(), street: String(a.street).trim(),
  building_no: toLatinDigits(a.buildingNo).trim(),
  postal_code: toLatinDigits(a.postalCode).trim() || null,
  additional_no: toLatinDigits(a.additionalNo).trim() || null,
  unit: String(a.unit || '').trim() || null, details: String(a.details || '').trim() || null,
  instructions: String(a.instructions || '').trim() || null,
  lat: a.lat == null || a.lat === '' ? null : Number(a.lat), lng: a.lng == null || a.lng === '' ? null : Number(a.lng),
});

export async function listAddresses() {
  const { data, error } = await marketDb.from('market_addresses').select(COLS).order('is_default', { ascending: false }).order('updated_at', { ascending: false });
  return { rows: (data || []).map(fromRow), error: error?.message ?? null };
}
/** Insert (no id) or update (id). user_id is the signed-in user; RLS refuses anything else. */
export async function saveAddress(a, userId, { makeDefault = false } = {}) {
  const row = { ...toRow(a), ...(makeDefault ? { is_default: true } : {}) };
  const q = a.id
    ? marketDb.from('market_addresses').update(row).eq('id', a.id).select(COLS).single()
    : marketDb.from('market_addresses').insert({ ...row, user_id: userId }).select(COLS).single();
  const { data, error } = await q;
  return { row: data ? fromRow(data) : null, error: error?.message ?? null };
}
export async function deleteAddress(id) {
  const { error } = await marketDb.from('market_addresses').delete().eq('id', id);
  return { error: error?.message ?? null };
}
export async function setDefaultAddress(id) {
  const { error } = await marketDb.from('market_addresses').update({ is_default: true }).eq('id', id);
  return { error: error?.message ?? null };
}
